import styled from '@emotion/styled';
import { Button } from 'antd';
import { colorConstants } from 'config/colorConstants';

export const StyledAppliedFiltersDetailPanel = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    padding: 16px 19px;
    border-radius: 12px;
    border: 1px solid ${colorConstants.tableColorSplit};
    background: ${colorConstants.white};
    box-shadow: ${colorConstants.modalContentShadow};

    .applied-filters-detail-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        width: 100%;
        min-height: 24px;
    }

    .applied-filters-detail-header-left {
        display: flex;
        min-width: 0;
        flex: 1;
        align-items: center;
        gap: 16px;
    }

    .applied-filters-detail-toggles {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 16px;
    }

    .applied-filters-detail-toggle {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        margin: 0;
        cursor: pointer;
        user-select: none;
    }

    .applied-filters-detail-toggle-label {
        font-size: 14px;
        line-height: 22px;
        font-weight: 400;
        color: ${colorConstants.blackTransparent88};
        white-space: nowrap;
    }

    .applied-filters-detail-toggle .ant-switch {
        min-width: 28px;
        height: 16px;
        line-height: 16px;
        box-shadow: none;

        &:focus,
        &:focus-visible,
        &:focus-within {
            box-shadow: none;
            outline: none;
        }

        .ant-switch-handle::before {
            box-shadow: none;
        }
    }

    .applied-filters-detail-toggle .ant-switch .ant-switch-handle {
        width: 12px;
        height: 12px;
    }

    .applied-filters-detail-toggle .ant-switch.ant-switch-checked .ant-switch-handle {
        inset-inline-start: calc(100% - 14px);
    }

    .applied-filters-detail-toggle .ant-switch.ant-switch-checked {
        background: ${colorConstants.violet};
    }

    .applied-filters-detail-toggle .ant-switch.ant-switch-checked:hover:not(.ant-switch-disabled) {
        background: ${colorConstants.purpleFontSelected};
    }

    .applied-filters-detail-title {
        margin: 0;
        font-size: 17px;
        line-height: normal;
        font-weight: 500;
        color: ${colorConstants.blackTitle};
    }

    .applied-filters-detail-close {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 16px;
        height: 16px;
        padding: 0;
        border: 0;
        background: transparent;
        color: ${colorConstants.blackTitle};
        cursor: pointer;
        font-size: 16px;
        line-height: 1;
    }

    .applied-filters-detail-divider.ant-divider-horizontal {
        margin: 0;
        border-top-color: ${colorConstants.greyAlt6};
    }

    .applied-filters-detail-rows {
        display: grid;
        grid-template-columns: max-content minmax(0, 1fr);
        column-gap: 8px;
        row-gap: 8px;
        width: 100%;
        padding-left: 3px;
        align-items: start;
    }

    .applied-filters-detail-row {
        display: contents;
    }

    .applied-filters-detail-row-label {
       padding-right: 12px;
        padding-block: 2px;
        font-size: 14px;
        line-height: 22px;
        color: ${colorConstants.colorTextDescription};
        white-space: nowrap;
    }

    .applied-filters-detail-tags {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        padding-block: 1px;
    }

    .applied-filters-detail-tag.ant-tag {
        margin: 0;
        padding: 1px 8px;
        border-radius: 4px;
        border-color: ${colorConstants.greyAlt};
        background: ${colorConstants.tableHeaderHoverBg};
        font-size: 12px;
        line-height: 20px;
        color: ${colorConstants.blackTransparent88};

        .ant-tag-close-icon {
            top: 0;
            color: ${colorConstants.blackTransparent88};
        }
    }

    .applied-filters-detail-empty {
        grid-column: 1 / -1;
        font-size: 14px;
        line-height: 22px;
        color: ${colorConstants.colorTextDescription};
    }
`;

export const StyledAppliedFiltersDetailPanelActions = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    width: 100%;
`;

const detailPanelButtonBase = `
    &.ant-btn {
        width: 80px;
        height: 32px;
        padding: 0 15px;
        border-radius: 6px;
        font-size: 14px;
        line-height: 22px;
        font-weight: 600;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }
`;

export const StyledAppliedFiltersDetailPanelCancelButton = styled(Button)`
    ${detailPanelButtonBase}

    &.ant-btn {
        border: 1px solid ${colorConstants.greyAlt};
        background: ${colorConstants.white};
        color: ${colorConstants.blackTransparent88};
        box-shadow: 0 2px 0 0 ${colorConstants.controlTmpOutline};

        &:hover,
        &:focus {
            border-color: ${colorConstants.greyAlt};
            background: ${colorConstants.white};
            color: ${colorConstants.blackTransparent88};
            box-shadow: 0 2px 0 0 ${colorConstants.controlTmpOutline};
        }
    }
`;

export const StyledAppliedFiltersDetailPanelApplyButton = styled(Button)`
    ${detailPanelButtonBase}

    &.ant-btn.ant-btn-primary {
        border: 1px solid ${colorConstants.violet};
        background: ${colorConstants.violet};
        color: ${colorConstants.white};
        box-shadow: 0 2px 0 0 ${colorConstants.controlOutline};

        &:hover,
        &:focus {
            background: ${colorConstants.purpleFontSelected} !important;
            border-color: ${colorConstants.purpleFontSelected} !important;
            color: ${colorConstants.white} !important;
            box-shadow: 0 2px 0 0 ${colorConstants.controlOutline};
        }
    }
`;
